import React from "react";

const ArrowEndIcon = ({ width = 25, height = 12, fill = "#686868", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25 5.77344L15 -6.53267e-05V11.5469L25 5.77344ZM0 5.77344V6.77344H16V5.77344V4.77344H0V5.77344Z"
        fill={fill}
      />
    </svg>
  );
};

export default ArrowEndIcon;

